import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';
import { showFirstLayerAction, hideInfoLayerAction } from '../../_flux/actions/catalog_configurator_actions';
import { hideInfoLayerAction as hideInfoLayerActionRego } from '../../_flux/actions/rego_lookup_actions';
import { hideInfoLayerAction as hideInfoLayerActionVehicle } from '../../_flux/actions/vehicle_configurator_actions';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';
import VehicleFilterStore from '../../_flux/stores/vehicle_configurator_store';

export function onBackClick() {
  const state = CatalogConfiguratorStore.getState();
  const regoState = RegoLookupStore.getState();
  const vehicleState = VehicleFilterStore.getState();

  if (vehicleState.infoLayerVisible) {
      hideInfoLayerActionVehicle();
  } else if (regoState.infoLayerVisible) {
      hideInfoLayerActionRego();
  } else if (state.infoLayerVisible) {
      hideInfoLayerAction();
  } else {
    showFirstLayerAction();
  }
}
